import axios from 'axios'

// App Imports
import { API_URL } from '../../../../setup/config/env'

// Actions

// Create 
export function listContact() {
    return dispatch => {
        return axios.get(API_URL + "/api/crm")
    }
}

export function getContact({ contactId }) {
    return dispatch => {
        return axios.get(API_URL + "/api/crm/" + contactId)
    }
}

export function listCrmTags() {
    return axios.get(API_URL + "/api/crm/tags");
}

export function fetchYelpData(location, term, offset, limit) {

    // Use this only for development

    // const mockData = Array.from({ length: 200 }, (_, index) => ({
    //     "id": `xajtELAqOULbR9-k-KJkdg-${index}`,
    //     "alias": `dutch-country-bakery-bristol-${index}`,
    //     "name": `Dutch Country Bakery ${index + 1}`,
    //     "image_url": "https://s3-media2.fl.yelpcdn.com/bphoto/HNKQuo4pT8ZeBiqzpEWblA/o.jpg",
    //     "is_closed": false,
    //     "url": `https://www.yelp.com/biz/dutch-country-bakery-bristol-${index + 1}?adjust_creative=2NJaxfgvvR1C0OIV8kA4mA&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=2NJaxfgvvR1C0OIV8kA4mA`,
    //     "review_count": Math.floor(Math.random() * 100) + 1,
    //     "categories": [
    //         { "alias": "farmersmarket", "title": "Farmers Market" },
    //         { "alias": "bakeries", "title": "Bakeries" }
    //     ],
    //     "rating": (Math.random() * 3 + 2).toFixed(1),
    //     "coordinates": { "latitude": 40.1184743 + Math.random() * 0.01, "longitude": -74.84419 + Math.random() * 0.01 },
    //     "transactions": ["delivery"],
    //     "price": "$$",
    //     "location": {
    //         "address1": `498 Green Ln ${index + 1}`,
    //         "address2": "",
    //         "address3": "Bristol Amish Market",
    //         "city": "Bristol",
    //         "zip_code": "19007",
    //         "country": "US",
    //         "state": "PA",
    //         "display_address": [
    //             `498 Green Ln ${index + 1}`,
    //             "Bristol Amish Market",
    //             "Bristol, PA 19007"
    //         ]
    //     },
    //     "phone": `+12158269971${index}`,
    //     "display_phone": `(215) 826-9971${index}`,
    //     "distance": (Math.random() * 5000 + 1000).toFixed(2),
    //     "business_hours": [],
    //     "attributes": {
    //         "business_temp_closed": null,
    //         "menu_url": null,
    //         "waitlist_reservation": null
    //     }
    // }));

    // if (process.env.NODE_ENV === 'development') {
    //     return new Promise((resolve) => {
    //         setTimeout(() => {
    //             const paginatedData = mockData.slice(offset, offset + limit);
    //             resolve({ data: { businesses: paginatedData, total: mockData.length } });
    //         }, 500);
    //     });
    // }
    return axios.get(API_URL + "/api/crm/yelp/search", {
        params: {
            location,
            term,
            limit,
            offset,
        },
        headers: {
            "origin": window.location.origin,
            "Content-Type": "application/json",
        },
    });
}

export function getTemplates() {
    return axios.get(API_URL + '/api/campaign/templates')
}

export function listClientConfig() {
    return axios.get(API_URL + '/api/clientConfig')
}

export function getClientConfig(clientConfigId) {
    return axios.post(
        `${API_URL}/api/clientConfig`, { _id: clientConfigId }
    );
}

export function listPlanLimit() {
    return axios.get(API_URL + '/api/planLimit')
}

export function getPlanLimit(planLimitId) {
    return axios.get(`${API_URL}/api/planLimit/${planLimitId}`)
}

export function listSaasPlans() {
    return axios.get(API_URL + '/api/saasPlan')
}

export function getSaasPlan(id) {
    return axios.get(`${API_URL}/api/saasPlan/${id}`)
}

export function listPlanModules() {
    return axios.get(API_URL + '/api/planModule')
}

export function getPlanModule(id) {
    return axios.get(`${API_URL}/api/planModule/${id}`)
}
export function getSaasConfig() {
    return axios.get(`${API_URL}/api/saasConfig`)
}

export function getCollections() {
    return axios.get(`${API_URL}/api/clientConfig/collections`)
}

export function getCollectionFields(collectionName) {
    return axios.get(`${API_URL}/api/clientConfig/collections/${collectionName}/fields`)
}
